"use strict";


var _               = require('underscore');
var ItemAttributes  = require('bunsen/collections/inventory/ItemAttributes');
var ItemAttribute   = require('bunsen/models/inventory/ItemAttribute');
var Attributes      = require('bunsen/collections/inventory/Attributes');

/**
 * @class ItemAttributesProductionType
 * @extends ItemAttributes
 */
var ItemAttributesProductionType = module.exports = ItemAttributes.extend();

//TODO Remove this logic from FE once BE has the ability to map certain attribute values to other attributes
var LIMITED_EDITION_LABEL = 'limited-edition';

_.extend(ItemAttributesProductionType.prototype, {

    /**
     * Returns true if this attribute is the limited edition one
     * Note:    Since attribute value IDs aren't constant, we're using the urlLabel (also not constant, but apparently more
     *          constant than the ID) find the appropriate id.
     *
     * @param  {Attributes} periods A collection containing groups of attribute period values to be used for reference
     * @return {Boolean}            True if this attribute is limited edition
     */
    isLimitedEdition: function (periods) {
        var attrCollection = (periods && new Attributes(periods)) || Attributes.getCollectionForKey(ItemAttribute.ATTRIBUTE_PRODUCTION_TYPE);
        var attrs = attrCollection.getItemAttributesCollection();
        var urlLabel = attrs.find(function (attr) {
            return attr.get('option.urlLabel') === LIMITED_EDITION_LABEL;
        });
        var limitedEditionId = urlLabel && urlLabel.get('option.id');

        var prodTypeId = this.at(0) && this.at(0).get('option.id');
        return parseInt(prodTypeId, 10) === limitedEditionId;
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/ItemAttributesProductionType.js
// module id = 2625
// module chunks = 63